export const SUCCESS_LIBRARY_TOPIC = "SUCCESS_LIBRARY_TOPIC";
export const SUCCESS_LIBRARY_SEARCH = "SUCCESS_LIBRARY_SEARCH";
export const LOADING_LIBRARY_TOPIC_SEARCH = "LOADING_LIBRARY_TOPIC_SEARCH";
export const LIBRARY_DATA_LOADING = "LIBRARY_DATA_LOADING";

//filters
export const SUCCESS_LIBRARY_FILTERS = "SUCCESS_LIBRARY_FILTERS";
export const LOADING_LIBRARY_FILTERS = "LOADING_LIBRARY_FILTERS";
export const LIBRARY_DATA_DOWNLOAD = "LIBRARY_DATA_DOWNLOAD";
